export default __webpack_public_path__ + "static/media/kybella.672b9d38.pdf";